<template>
  <div v-if="canShow" class="notifications-container" :style="containerStyle">
    <transition name="fade">
      <div v-show="!turnedGacha" class="notifications-wrapper">
        <div
          class="balloon"
          ref="balloon"
          v-if="isMultipleTickets"
          :style="{ top: `${balloonTop}px` }"
        >
          <p>
            <span>ガチャ券を{{notifications.length}}枚獲得しました！</span>
          </p>
        </div>
        <component
          :is="canCarousel ? 'flickity' : 'div'"
          id="flickity"
          :class="!canCarousel && 'cantCarousel'"
          ref="flickity"
          :options="flickityOptions"
          :style="{ paddingBottom: `${carouselPaddingBottom}px` }"
          @change="onChangeSlide"
        >
          <div
            class="carousel-cell"
            :class="!canCarousel && 'cantCarousel'"
            v-for="(notification, i) in notifications"
            :key="i"
          >
            <gacha-notify-card
              :notification="notification"
              :index="i"
              @card-loaded="({ top, bottom }) => cardLoaded({ top, bottom })"
            />
          </div>
        </component>
        <ul v-if="canCarousel && isMultipleTickets" class="dots" ref="dots" :style="{ top: `${dotsTop}px` }">
          <li v-for="page in notifications.length" :key="page" :class="page === currentPage && 'active'" />
        </ul>
        <div class="button-container" ref="buttonContainer" :style="{ top: `${buttonContainerTop}px` }">
          <button @click="tryGacha">ガチャを引く</button>
          <button @click="closeGachaModal">閉じる</button>
        </div>
      </div>
    </transition>
    <gacha-lottery-modal
      ref="lotteryModal"
      :needs-background-color="false"
      @close-lottery-modal="closeGachaModal"
    />
    <error-popup
      v-if="error"
      :title="error.title"
      :message="error.message"
      :label="'閉じる'"
      @submit="clearError"
      @close="clearError"
    />
  </div>
</template>

<script>
import Flickity from 'vue-flickity-2/src/Flickity'
import 'vue-flickity-2/dist/vue-flickity-2.css'
import { mapActions, mapGetters } from 'vuex'
import DateFormatter from '@/utils/DateFormatter'
import ErrorPopup from '@/components/Modal/ErrorPopup.vue'
import GachaNotifyCard from '@/views/Gacha/NotifyCard.vue'
import GachaLotteryModal from '@/views/Gacha/LotteryModal.vue'

export default {
  name: 'GachaNotify',
  components: { GachaLotteryModal, GachaNotifyCard, ErrorPopup, 'flickity': Flickity },
  data() {
    return {
      apiType: '4',
      flickityOptions: {
        prevNextButtons: false,
        pageDots: false,
        dragThreshold: 30
      },
      notifications: [],
      balloonOffsetY: -1,
      balloonTipHeight: 15,
      buttonContainerOffsetY: -1,
      currentPage: 1,
      turnedGacha: false
    }
  },
  created() {
    document.title = 'ガチャ券獲得'
    document.documentElement.className = 'transparent'
    document.body.className = 'transparent'
    this.fetchData()
  },
  computed: {
    ...mapGetters({
      error: 'Gacha/error'
    }),
    canShow() {
      return this.notifications.length > 0
    },
    canCarousel() {
      const ua = navigator.userAgent
      if (ua.indexOf('Android') > 0) {
        const version = parseFloat(ua.slice(ua.indexOf('Android') + 8))
        if (version <= 4.4) {
          return false
        }
      }
      return true
    },
    isMultipleTickets() {
      return this.notifications.length > 1
    },
    balloonTop() {
      const balloonHeight = this.$refs.balloon ? (this.$refs.balloon.clientHeight + this.balloonTipHeight) : 0
      return this.balloonOffsetY - balloonHeight
    },
    dotsTop() {
      return this.buttonContainerOffsetY
    },
    buttonContainerTop() {
      const dotsHeight = this.$refs.dots ? this.$refs.dots.clientHeight : 20
      return this.buttonContainerOffsetY + dotsHeight
    },
    carouselPaddingBottom() {
      return 120
    },
    containerStyle() {
      return { opacity: (!this.turnedGacha && this.buttonContainerOffsetY > -1) || this.turnedGacha ? 1 : 0 }
    }
  },
  methods: {
    ...mapActions('Native', ['actionRequestToken', 'actionRequestCloseGachaModal']),
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('Gacha', ['fetchNotifications', 'setError']),
    async fetchData() {
      const accTime = new DateFormatter().format(new Date())

      const fetch = async ({ token, accTime, userId }) => {
        this.actionToggleLoading(true)
        this.notifications = await this.fetchNotifications({ token, accTime, userId })
        this.actionToggleLoading(false)
        if (!this.canShow) {
          this.actionRequestCloseGachaModal()
        }
      }

      window.receivedToken = async (payload) => {
        const json = JSON.parse(payload)
        await fetch({ token: json.app_token, accTime, userId: json.user_id })
      }
      this.actionRequestToken({ apiType: this.apiType, acc_time: accTime })
      // FIXME: for development
      // await fetch({ token: 'a', accTime, userId: '89a1636f6b85c0d7' })
    },
    cardLoaded({ top, bottom }) {
      this.balloonOffsetY = (this.balloonOffsetY === -1 || top < this.balloonOffsetY) ?
        top :
        this.balloonOffsetY

      this.buttonContainerOffsetY = (this.buttonContainerOffsetY === -1 || this.buttonContainerOffsetY < bottom) ?
        bottom :
        this.buttonContainerOffsetY
    },
    onChangeSlide(index) {
      this.currentPage = index + 1
    },
    tryGacha() {
      this.turnedGacha = true
      if (this.isMultipleTickets) {
        this.$refs.lotteryModal.showMultipleTicketsNotice()
      } else {
        this.$refs.lotteryModal.tryGacha(this.notifications[0].id)
      }
    },
    closeGachaModal() {
      this.actionRequestCloseGachaModal()
    },
    clearError() {
      this.setError(null)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0;
  appearance: none!important;;
  web-kit-appearance: none!important;
  -webkit-tap-highlight-color:rgba(0,0,0,0);

  &:disabled, &.disabled {
    opacity: 0.4;
  }
}

::v-deep .fade-enter-active, ::v-deep .fade-leave-active {
  transition: opacity 0.2s;
}
::v-deep .fade-enter,
::v-deep .fade-faster-enter,
::v-deep .fade-leave-to,
::v-deep .fade-faster-leave-to {
  opacity: 0;
}

.notifications-container {
  height: 100%;
  // FIXME: for development
  //background: rgba(0, 0, 0, 0.5);
  transition: opacity 0.5s;

  .notifications-wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;

    .balloon, .button-container {
      position: absolute;
    }

    .balloon {
      display: flex;
      justify-content: center;
      width: 100%;

      p {
        background: #dc0a16;
        padding: 6px 12px;
        border-radius: 6px;
        color: #ffffff;
        font-weight: bold;

        &::before {
          content: '';
          position: absolute;
          display: block;
          width: 0;
          height: 0;
          left: 0;
          right: 0;
          margin: auto;
          bottom: -10px;
          border-top: 10px solid #dc0a16;
          border-right: 6px solid transparent;
          border-left: 6px solid transparent;

        }
      }
    }

    #flickity {
      flex: auto;
      height: 100%;

      &.cantCarousel {
        display: flex;
        overflow: scroll;
      }

      .carousel-cell {
        &.cantCarousel {
          flex-shrink: 0;
        }

        width: 70%;
        height: 100%;
        padding: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .dots {
      display: flex;
      justify-content: center;
      padding: 12px 0;
      position: absolute;
      left: 0;
      right: 0;

      & > * + * {
        margin-left: 6px;
      }

      li {
        list-style: none;
        background:  none;
        border: 1px solid #ffffff;
        width: 10px;
        height: 10px;
        border-radius: 10px;

        &.active {
          background: rgba(255, 255, 255, 1.0);
        }
      }
    }

    .button-container {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 15px;

      & > * + * {
        margin-top: 10px;
      }

      button {
        font-size: 15px;
        border: none;
        cursor: pointer;
        outline: none;
        appearance: none!important;;
        web-kit-appearance: none!important;
        -webkit-tap-highlight-color:rgba(0,0,0,0);

        &:disabled, &.disabled {
          opacity: 0.4;
        }

        width: 68%;
        height: 45px;
        display: block;
        background: #f8b616;
        border-radius: 6px;
        padding: 10px;
        color: #5a2200;
        font-weight: bold;
      }
    }
  }
}

</style>
